export default {
  es: {
    message: {
      hello: "Hola",
      username: "Nombre de usuario",
      password: "Contraseña",
      register: "registro",
      reset: "reiniciar",
      login: "Iniciar sesión",
      signin: "Para realizar la encuesta, ingrese la siguiente información.",
      first: "Nombre de pila",
      last: "Apellido",
      zip: "Código postal",
      check: "Comprobar usuario",
      address: "Dirección",
      city: "Ciudad",
      state: "Estado",
      phone: "Teléfono",
      email: "Correo electrónico",
      required: "Requerido",
      confirm: "confirmar",
      update: "actualizar",
      password_reset: "cambiar la contraseña",
      confirm1:
        " asegúrate de que la siguiente información sea correcta, luego haz clic en ",
      confirm2: " para continuar con tu encuesta",
      cancel: "cancelar",
      registering:
        " parece que no te tenemos en nuestro sistema. Asegúrate de que la siguiente información sea correcta antes de registrarte:",
      redirect: "Serás redirigido a Búsqueda de usuarios en breve.",
      map: "Seleccione un lugar en el mapa que corresponda a su comentario",
      surveyError: "Error inesperado, comuníquese con un miembro del personal",
      thanks: "Gracias por participar en esta encuesta",
      selectSurvey: "Seleccione una encuesta de la lista a continuación:",
      stakeholderChoice: "Desde aquí puede finalizar su sesión o realizar otra encuesta.",
      finish: "Terminar",
      nextSurvey: "Próxima Encuesta"
    }
  },
  en: {
    message: {
      hello: "Hi",
      username: "Username",
      password: "Password",
      register: "register",
      reset: "reset",
      login: "login",
      signin: "To take the survey, please enter the following information.",
      first: "First Name",
      last: "Last Name",
      zip: "Postal Code",
      check: "Check Stakeholder",
      address: "Address",
      city: "City",
      state: "State",
      phone: "Phone",
      email: "Email",
      required: "Required",
      confirm: "confirm",
      update: "update",
      password_reset: "Password Reset",
      confirm1: " please make sure the following info is correct, then click ",
      confirm2: " to continue on to your survey.",
      cancel: "cancel",
      registering:
        " it looks like we don't have you in our system. Make sure the following information is correct before registering:",
      redirect: "You will be redirected to Stakeholder Lookup shortly.",
      map: "Please select a location on the map that pertains to your comment.",
      surveyError: "Unexpected error, please contact a staff member",
      thanks: "Thank you for participating in this survey",
      selectSurvey: "Select a survey from the list below:",
      stakeholderChoice: "From here you can either end your session or take another survey.",
      finish: "Finish",
      nextSurvey: "Next Survey"
    }
  }
};